// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const BusinessStructureDoc: MarkdocTagRegistration = {
  tag: 'business-structure-doc',
  component: 'BusinessStructureDoc',
  children: [
    'heading',
    'paragraph',
    'image',
    'table',
    'tag',
    'fence',
    'blockquote',
    'partial',
    'business-structure-doc',
  ],
};
